import React,{useState} from 'react'
import IncomesForm from './components/IncomesForm'

const IncomeAdd = () => {

    const [mode,setMode] = useState('Adding');

    return (
        <div>
            <IncomesForm mode={mode} setMode={setMode} />
        </div>
    )
}

export default IncomeAdd